/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.09.2016.
 */

import React, {Component, PropTypes} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';

import ScrollArea from '../../../../ScrollArea';

import {
  StubFunc,
} from '../../../../../utils';

import {
  AddNotification,
  RemoveNotification
} from '../../../../../actions/notifications/actions-notifications';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';

import _get from 'lodash/get';
import _find from 'lodash/find';
import _merge from 'lodash/merge';

class NotificationProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
      momentStart: moment.unix(_get(this.props, 'notification.start')),
      momentEnd: moment.unix(_get(this.props, 'notification.end'))
    };
  }

  componentDidMount() {

    if (this.props.notification.id) this._fetchNotificationData(this.props.notification);
  }

  componentWillReceiveProps(newProps) {
    let newState = {};

    if (this.props.notification.id !== newProps.notification.id) {
      newState = _merge(newState, {
        picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
        momentStart: moment.unix(newProps.notification.start),
        momentEnd: moment.unix(newProps.notification.end)
      });

      this._fetchNotificationData(newProps.notification);
    }

    this.setState(newState);
  }

  _fetchNotificationData(notification) {

    lh.models.epgEvent.methods
      .getPosterUrl(notification.program, {
        crop: {x: 460, y: 270},
        cache: false
      })
      .then((url) => {
        this.setState({picture: url});
      }, () => {
        this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`});
      });
  };

  _removeNotification(notification) {

    this.props.RemoveNotification(notification.id);
  }

  _closeProfile() {

    this.props.onClose();
  }

  _hasSubTitle() {

    return _get(this.props, 'notification.title') !== _get(this.props, 'notification.program.title');
  }

  _renderNotificationButton() {

    return (
      <div className="mt-">
        <div className="color-grey pv-"><Translate content="profile.notification.not_remind" /></div>
        <div>
          <a href="javascript:void(0)" className="hover" onClick={this._removeNotification.bind(this, this.props.notification)}>
            <i className="ic ic-notification-remove ic-24px"></i>
          </a>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.notification.id) return <div className="profile event-inf-example bg-black radius"><DivLoader loading={true} /></div>;

    return (
      <div className="profile event-inf-example bg-black radius">
        <DivLoader loading={this.props.inProgress} />
        <div className="profile-cols relative">
          <div className="channel-player-dummy relative">
            <div className="crow no-gutter player-dummy" style={{display: 'block'}}>
              <img id="profile_poster" src={this.state.picture} alt="" />
            </div>
          </div>
          <div className="block-3 event-desc">
            <div>
              <div className="channel-title mt+">
                <b>{_get(this.props, 'channel.title', '')}</b>
              </div>
              <br />
              <div className="profile-bigtext">
                {this.state.momentStart.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
              </div>
              <div className="program-title">
                {_get(this.props.notification, 'program.title', '')}
              </div>
              <ScrollArea
                speed={0.8}
                className="color-grey profile-text"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  <div className="program-title mb-">
                    {this._hasSubTitle() && <span className="program-title color-white">{_get(this.props, 'notification.title')}</span>}
                  </div>
                  {_get(this.props.notification, 'description', '')}
                </div>
              </ScrollArea>
            </div>
          </div>
          <div className="block-1"></div>
          <div className="block-1 col-last">
            <div className="profile-r pr">
              <div className="profile-actions pr">
                {this._renderNotificationButton()}
              </div>
            </div>
          </div>
        </div>
        <a href="javascript:void(0)" className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
      </div>
    );
  }
}

NotificationProfile.propTypes = {
  notificationId: PropTypes.number.isRequired,
  notification: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  AddNotification: PropTypes.func.isRequired,
  RemoveNotification: PropTypes.func.isRequired
};

NotificationProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from Notification Profile')
};

const mapStateToProps = function ({notifications: {notifications}}, ownProps) {
  let collection = _get(notifications, 'collection', []);
  let notification = _find(collection, {id: ownProps.notificationId}) || {};

  return {
    notification: notification,
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({
    AddNotification,
    RemoveNotification
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/Notification/notification-profile.js